var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReferralsTable',{attrs:{"is-loading":_vm.isLoading,"data":_vm.referralData,"has-results":_vm.hasResults,"data-title":_vm.startCase(_vm.type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }